import { tooltipClasses } from "@mui/material";
import { ReactNode } from "react";
import { TbInfoCircle } from "react-icons/tb";

import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { CommonStatusItem } from "@/types/global";

function CommonTooltip({
    tooltip,
    children,
    tooltipChild,
}: {
    tooltipChild?: ReactNode;
    tooltip: CommonStatusItem;
    children?: ReactNode;
}) {
    return (
        <NoMaxWidthTooltip
            arrow
            sx={{
                [`& .${tooltipClasses.tooltip}`]: {
                    backgroundColor: "white",
                    border: "none",
                    padding: "0px !important",
                    fontSize: 11,
                },
            }}
            title={<HotelStatusTooltip status={tooltip}>{tooltipChild}</HotelStatusTooltip>}
        >
            <div className="max-w-fit max-h-fit !ml-auto">{children || <TbInfoCircle />}</div>
        </NoMaxWidthTooltip>
    );
}

export default CommonTooltip;
